import React, { useState } from 'react';

const ServiceModal = ({ service, onClose }) => {
  const [selectedSubImage, setSelectedSubImage] = useState(0);

  if (!service) return null;

  const subCategories = service.subCategories || [];
  const current = subCategories[selectedSubImage] || {};
  const hasMultiple = subCategories.length > 1;

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedSubImage(prev => (prev === 0 ? subCategories.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedSubImage(prev => (prev === subCategories.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 text-white hover:text-gray-300 transition z-10"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="bg-white rounded-lg overflow-hidden max-h-[85vh] overflow-y-auto">
          {/* Service header */}
          <div className="p-6 bg-blue-600 text-white">
            <div className="flex items-center gap-3">
              <span className="text-4xl">{service.icon}</span>
              <div>
                <h2 className="text-2xl font-bold">{service.title}</h2>
                <p className="text-blue-100">{service.description}</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src={current.image}
              alt={current.title}
              className="w-full h-auto max-h-[50vh] object-contain bg-gray-100"
              loading="lazy"
              decoding="async"
            />
            {hasMultiple && (
              <>
                <button onClick={handlePrev} className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-3 transition shadow-lg">
                  <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button onClick={handleNext} className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-3 transition shadow-lg">
                  <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </>
            )}
          </div>

          {/* Details */}
          <div className="p-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">{current.title}</h3>
            <p className="text-gray-600 text-base leading-relaxed mb-4">{current.description}</p>

            {hasMultiple && (
              <div className="flex items-center justify-center gap-2 mt-6">
                {subCategories.map((sub, idx) => (
                  <button
                    key={`${sub.title}-${sub.image}`}
                    onClick={() => setSelectedSubImage(idx)}
                    className={`h-2 rounded-full transition-all ${idx === selectedSubImage ? 'w-8 bg-blue-600' : 'w-2 bg-gray-300'}`}
                  />
                ))}
              </div>
            )}
            <div className="text-center text-sm text-gray-500 mt-4">
              {selectedSubImage + 1} / {subCategories.length}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
